/* eslint-disable no-eval */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-unresolved
const utils = require('../utils');
/* globals google */
const markers = [];
let latitude;
let longitude;
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */

const bindEventToMarkers = () => {
    markers.forEach((m) => {
        google.maps.event.addListener(m, 'click', () => {
            const foundNode = Array.from(
                document.querySelectorAll('input.form-check-input.select-store-input'),
            ).find(el => JSON.parse(el.getAttribute('data-store-info')).name === m.title);

            if (foundNode) {
                foundNode.click();
            } else {
                foundNode.checked = false;
            }
        });
    });
};

function appendToUrl(url, params) {
    let newUrl = url;
    newUrl
        += (newUrl.indexOf('?') !== -1 ? '&' : '?')
        + Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps(lat, long) {
    const infowindow = new google.maps.InfoWindow();

    const style = [
        { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#bdbdbd' }],
        },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#9e9e9e' }],
        },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
        {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#757575' }],
        },
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#616161' }],
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#9e9e9e' }],
        },
        { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
        {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [{ color: '#eeeeee' }],
        },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    ];

    // Init U.S. Map in the center of the viewport
    const latlng = new google.maps.LatLng(lat || 37.09024, long || -95.712891);
    const mapOptions = {
        scrollwheel: false,
        zoom: 4,
        center: latlng,
        styles: style,
    };

    const map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    let mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    const bounds = new google.maps.LatLngBounds();

    const markerImgSRC = $('#markerImageSRC').val();

    Object.keys(mapdiv).forEach((key) => {
        const item = mapdiv[key];
        const lable = parseInt(key, 10) + 1;
        const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        const marker = new google.maps.Marker({
            position: storeLocation,
            map,
            title: item.name,
            icon: {
                url: markerImgSRC,
            },
            labelClass: 'maps-marker',
        });

        marker.addListener('click', () => {
            infowindow.setOptions({
                content: item.infoWindowHtml,
            });
            infowindow.open(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
        markers.push(marker);
    });
    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
    google.maps.event.addListenerOnce(map, 'idle', () => {
        bindEventToMarkers();
    });

    $(document.body).on('click', '.store-map-open-marker', (e) => {
        const mapWrapper = $('.map-canvas');
        const mapTab = $('.storelocator-map-tab');
        const markerID = $(e.currentTarget).parents('.results > .card-body').index();
        google.maps.event.trigger(markers[markerID], 'click');
        map.setCenter(markers[markerID].getPosition());

        if (mapWrapper.css('display') === 'none') {
            mapTab.trigger('click');
        }
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data, firstCheckoutLoad) {
    const defaultResultsContainer = $('.store-locator-container .results');
    const $defaultGeolocationDiv = $('.default-geolocation-stores');
    const $defaultGeolocationCondition = firstCheckoutLoad && $defaultGeolocationDiv.length;
    const $resultsDiv = $defaultGeolocationCondition
        ? $defaultGeolocationDiv : defaultResultsContainer;
    const $mapDiv = $('.map-canvas');
    const hasResults = data.stores.length > 0;


    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv
        .empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps(data.searchKey.lat, data.searchKey.long);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if ($defaultGeolocationCondition) {
        defaultResultsContainer.parents('.results-card').hide();
    } else {
        $('.default-geolocation-stores').remove();
        defaultResultsContainer.parents('.results-card').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element, firstCheckoutLoad) {
    const dialog = element.closest('.in-store-inventory-dialog');
    const spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    const $form = element.closest('.store-locator');
    const radius = $('.results').data('radius');
    let url = $form.attr('action');
    const urlParams = { radius };

    const payload = $form.is('form')
        ? $form.serialize()
        : { postalCode: $form.find('[name="postalCode"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success(data) {
            spinner.stop();
            updateStoresResults(data, firstCheckoutLoad);
            $('.select-store').prop('disabled', true);
            // eslint-disable-next-line func-names
            $('.toggle').on('click', (e) => {
                const content = $(e.currentTarget).next();
                $(content).toggle();
                $(content)
                    .next()
                    .toggle();
                return false;
            });
        },
    });
    return false;
}

module.exports = {
    init: () => {
        const hasGoogleApi = $('.map-canvas').attr('data-has-google-api');

        latitude = $('#mapLatitude').val();
        longitude = $('#mapLongitude').val();

        if (hasGoogleApi && $('#Stores-AllStores').length <= 0) {
            const searchElement = $('.btn-storelocator-search[type="button"]');
            maps(latitude, longitude);
            search(searchElement);
        } else {
            const noApiKey = $('.store-locator-no-apiKey');
            if (noApiKey.length) {
                noApiKey.removeClass('d-none');
            }
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },
    detectLocation: () => {
        // clicking on detect location.
        $('.detect-location').on('click', () => {
            $.spinner().start();

            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition((position) => {
                const $detectLocationButton = $('.detect-location');
                let url = $detectLocationButton.data('action');
                const radius = $('.results').data('radius');
                const urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                };

                url = appendToUrl(url, urlParams);
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: (data) => {
                        $.spinner().stop();
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                    },
                });
            });
        });
    },
    search: () => {
        const docReady = $(document);
        docReady.find('.store-locator-container form.store-locator').on('submit', (e) => {
            e.preventDefault();
            search($(e.currentTarget));
        });

        // Start StoreLocator search pressing button form
        docReady.find('.store-locator-container .btn-storelocator-search[type="button"]').on('click', (e) => {
            e.preventDefault();
            search($(e.currentTarget));
        });

        // Start StoreLocator search pressing enter button
        $('#store-postal-code').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                search($(e.currentTarget));
            }
        });

        docReady.find('.jumbotron .map-canvas').on('ready', (e) => {
            search($(e.currentTarget));
        });

        const storeLocatorBtn = $('.btn-storelocator-search');
        if (storeLocatorBtn.length && $('#Stores-AllStores').length <= 0) {
            const isDefaultSearch = !$('.results-card .results.striped').find('.store-locator-no-results').length;
            search(storeLocatorBtn, isDefaultSearch);
        }
    },
    changeRadius: () => {
        $('.store-locator-container .radius').on('change', (e) => {
            const thisTarget = $(e.currentTarget);
            const radius = thisTarget.val();
            const searchKeys = $('.results').data('search-key');
            let url = thisTarget.data('action-url');
            let urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode,
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long,
                };
            }

            url = appendToUrl(url, urlParams);
            const dialog = thisTarget.closest('.in-store-inventory-dialog');
            const spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: (data) => {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                },
            });
        });
    },
    updateSelectStoreButton() {
        $('body').on('change', '.select-store-input', (e) => {
            e.preventDefault();
            const storePickupMode = utils.getCookie('storePickupMode');
            const selectedStore = $('.store-locator-container input.select-store-input:checked');

            let storeDetailsHtml;
            if (storePickupMode === 'modal') {
                $('#pickup-modal').modal('toggle');
                storeDetailsHtml = selectedStore
                    .siblings('label')
                    .find('.store-details')
                    .html();
            } else {
                storeDetailsHtml = selectedStore
                    .parent()
                    .find('.store-details')
                    .html();
            }

            const data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                storeByDefault: selectedStore.data('store-default'),
                searchPostalCode: $('#store-postal-code').val(),
                storeDetailsHtml,
                event: e,
                selectStoreText: selectedStore.data('select-text'),
                authenticated: selectedStore.data('authenticated'),
            };

            $('body').trigger('store:selected', data);
        });
    },
    mobileTabs() {
        $(document.body).on('click', '.mobile-tabs span', (e) => {
            const thisTab = $(e.currentTarget);
            const thisTarget = thisTab.data('target');
            const resultsCard = $('.results-card');

            $('.mobile-tabs span').not(thisTab).removeClass('active');
            thisTab.addClass('active');

            if (thisTarget === 'list') {
                resultsCard.addClass('active');
            } else {
                resultsCard.removeClass('active');
            }
        });
    },
    markers,
    selectStore() {
        $('.store-locator-container').on('click', '.select-store', ((e) => {
            e.preventDefault();
            const selectedStore = $(':checked', '.results-card .results');
            const data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e,
            };

            $('body').trigger('store:selected', data);
        }));
    },
};
